
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
import KeywordProtectedPage from './MyPage';
function Ashtavinayakdarshancab() {



    const cardData =
    {
        keyword: '  Ashtavinayak Darshan Cab',
        heading: 'Mauli Cabs: Ashtavinayak Darshan Cab',
        headingDescription: 'Mauli Cabs offers comfortable and reliable Ashtavinayak Darshan cab services, making your spiritual journey smooth, peaceful, and memorable. Whether you are traveling solo, with family, or in a group, we provide a range of well-maintained vehicles including sedans, SUVs, and tempo travellers to suit your needs. With experienced drivers familiar with the Ashtavinayak route, transparent pricing, no hidden charges, and a strong focus on punctuality and customer satisfaction, Mauli Cabs ensures a hassle-free and divine experience across all eight revered Ganpati temples.',

        top: 'Top Places to Visit in Ashtavinayak with Mauli Cabs',

"topPlaces": [
    {
        "title": "Mayureshwar Temple, Morgaon",
        "description": "Considered the most important among the Ashtavinayak temples, Mayureshwar Temple is dedicated to Lord Ganesha riding a peacock and is located in Morgaon, Pune district."
    },
    {
        "title": "Siddhivinayak Temple, Siddhatek",
        "description": "Situated on a hillock along the Bhima River, Siddhivinayak Temple is where Lord Vishnu is believed to have defeated demons by worshipping Lord Ganesha."
    },
    {
        "title": "Ballaleshwar Temple, Pali",
        "description": "Ballaleshwar Temple in Pali is unique as it is the only temple where Lord Ganesha is known by his devotee's name, Ballal. It is famous for its historic architecture."
    },
    {
        "title": "Varadvinayak Temple, Mahad",
        "description": "Located in Mahad near Khopoli, Varadvinayak Temple symbolizes the boon-giving aspect of Lord Ganesha and offers a serene and spiritual environment."
    },
    {
        "title": "Chintamani Temple, Theur",
        "description": "The Chintamani Temple at Theur is believed to be the place where Lord Ganesha restored the precious Chintamani jewel to sage Kapila, thus relieving his worries."
    },
    {
        "title": "Girijatmaj Temple, Lenyadri",
        "description": "Set amidst the Buddhist caves of Lenyadri, Girijatmaj Temple is unique as it is carved into a single stone hill and represents the childhood form of Lord Ganesha."
    },
    {
        "title": "Vighnahar Temple, Ozar",
        "description": "Vighnahar Temple at Ozar is dedicated to the remover of obstacles, Lord Ganesha, and is known for its beautiful architecture and peaceful surroundings."
    },
    {
        "title": "Mahaganapati Temple, Ranjangaon",
        "description": "Mahaganapati Temple in Ranjangaon houses a majestic idol of Ganesha and is believed to have been worshipped by Lord Shiva before defeating the demon Tripurasura."
    }
],

"services": [
    {
      "name": "Cab for Ashtavinayak Darshan",
      "description": "Book a cab for the sacred Ashtavinayak Darshan from Pune. Comfortable rides with experienced drivers for a spiritual journey."
    },
    {
      "name": "Ashtavinayak Darshan Package from Pune",
      "description": "Choose from well-planned Ashtavinayak Darshan packages from Pune. Includes sightseeing, temple visits, and flexible durations."
    },
    {
      "name": "Ashtavinayak Darshan from Pune in 2 Days",
      "description": "Perfect 2-day itinerary for Ashtavinayak Darshan from Pune with night halt options and guided temple visits."
    },
    {
      "name": "Pune to Ashtavinayak Taxi Service",
      "description": "Hire reliable taxis from Pune for the complete Ashtavinayak Yatra. Various car options available to match your needs."
    },
    {
      "name": "Pune to Ashtavinayak Tour Package",
      "description": "All-inclusive Ashtavinayak tour packages from Pune. Enjoy a smooth and spiritually enriching trip."
    },
    {
      "name": "Pune to Ashtavinayak Darshan Package",
      "description": "Book your Ashtavinayak Darshan Package from Pune with expert drivers and clean, comfortable vehicles."
    },
    {
      "name": "Cheapest Ashtavinayak Tour from Pune",
      "description": "Affordable and budget-friendly Ashtavinayak tour options starting from Pune. Great value with quality service."
    },
    {
      "name": "Cheapest Tempo Traveller for Ashtavinayak Tour from Pune",
      "description": "Rent the most affordable tempo traveller for your Ashtavinayak tour from Pune. Ideal for groups and families."
    },
    {
      "name": "Pune to Ashtavinayak Cab",
      "description": "Travel conveniently with a cab from Pune to all eight Ashtavinayak temples. Flexible schedules and vehicle choices."
    },
    {
      "name": "Ashtavinayak Yatra Tour Cabs",
      "description": "Comfortable cabs for the full Ashtavinayak Yatra. Safe, timely, and hassle-free travel from Pune."
    },
    {
      "name": "Pune to Ashtavinayak Tempo Traveller on Rent",
      "description": "Hire a tempo traveller from Pune for your Ashtavinayak trip. Spacious and cost-effective travel option."
    },
    {
      "name": "Pune to Ashtavinayak Mini Bus on Rent",
      "description": "Rent a mini bus from Pune for Ashtavinayak Darshan. Best suited for larger groups seeking comfort."
    },
    {
      "name": "Pune to Ashtavinayak 17 Seater Bus on Rent",
      "description": "Perfect for group tours—book a 17-seater bus for your Ashtavinayak Yatra from Pune today."
    },
    {
      "name": "Pune to Ashtavinayak Ertiga on Rent",
      "description": "Rent an Ertiga for a comfortable and smooth Ashtavinayak tour from Pune. Ideal for families."
    },
    {
      "name": "Ashtavinayak Tour from Pune by Car Package",
      "description": "Book a complete car package from Pune for your Ashtavinayak Darshan. Customized travel plans available."
    },
    {
      "name": "Pune to Ashtavinayak Innova Crysta on Rent",
      "description": "Travel in luxury with an Innova Crysta on rent for Ashtavinayak Darshan from Pune. Ample space and comfort guaranteed."
    },
    {
      "name": "Pune to Ashtavinayak Taxi Fare",
      "description": "Get transparent taxi fares for your Pune to Ashtavinayak trip. No hidden charges, only fair pricing."
    }
  ],
  "tableData": [
    ["Cab for Ashtavinayak Darshan", "Ashtavinayak Darshan Package from Pune"],
    ["Ashtavinayak Darshan from Pune in 2 Days", "Pune to Ashtavinayak Taxi Service"],
    ["Pune to Ashtavinayak Tour Package", "Pune to Ashtavinayak Darshan Package"],
    ["Cheapest Ashtavinayak Tour from Pune", "Cheapest Tempo Traveller for Ashtavinayak Tour from Pune"],
    ["Pune to Ashtavinayak Cab", "Ashtavinayak Yatra Tour Cabs"],
    ["Pune to Ashtavinayak Tempo Traveller on Rent", "Pune to Ashtavinayak Mini Bus on Rent"],
    ["Pune to Ashtavinayak 17 Seater Bus on Rent", "Pune to Ashtavinayak Ertiga on Rent"],
    ["Ashtavinayak Tour from Pune by Car Package", "Pune to Ashtavinayak Innova Crysta on Rent"],
    ["Pune to Ashtavinayak Taxi Fare", ""]
  ],

"whychoose": [
    {
        "WhyChooseheading": "Dedicated Ashtavinayak Darshan Routes",
        "WhyChoosedescription": "Mauli Cabs offers specially curated cab services for Ashtavinayak Darshan, covering all eight revered Ganpati temples in Maharashtra. Our routes are optimized to ensure a spiritually fulfilling and time-efficient journey."
    },
    {
        "WhyChooseheading": "Comfortable Multi-Day Travel",
        "WhyChoosedescription": "Our cabs are equipped for long-distance travel, offering clean, air-conditioned, and comfortable vehicles perfect for multi-day Ashtavinayak pilgrimages with family or groups."
    },
    {
        "WhyChooseheading": "Experienced Pilgrimage Drivers",
        "WhyChoosedescription": "Our drivers are not only professional but also familiar with the Ashtavinayak circuit, temple timings, and best routes. Their knowledge ensures a smooth and hassle-free darshan experience."
    },
    {
        "WhyChooseheading": "Flexible Packages and Itineraries",
        "WhyChoosedescription": "Choose from one-day, two-day, or custom Ashtavinayak Darshan packages. Mauli Cabs provides complete flexibility to plan your trip according to your convenience and pace."
    },
    {
        "WhyChooseheading": "Affordable Pilgrimage Pricing",
        "WhyChoosedescription": "We offer budget-friendly pricing with no hidden charges for Ashtavinayak Darshan tours. Get value-for-money cab services without compromising on comfort or reliability."
    },
    {
        "WhyChooseheading": "24/7 Booking and Support",
        "WhyChoosedescription": "Book your Ashtavinayak Darshan Cab anytime with our easy online booking system. Our support team is available 24/7 to assist you with bookings, schedule changes, and travel guidance."
    },
    {
        "WhyChooseheading": "Safe and Devotional Journey",
        "WhyChoosedescription": "Your safety and peace of mind are our priorities. All vehicles are sanitized, GPS-enabled, and driven by verified drivers who ensure a respectful and secure pilgrimage experience."
    },
    {
        "WhyChooseheading": "Group and Family Friendly Options",
        "WhyChoosedescription": "Travel together in comfort with our spacious SUVs, tempo travelers, or luxury vans—ideal for family groups or devotees traveling together for the Ashtavinayak Yatra."
    }
]





























    }


    const faqData = [
        {
            question: 'How do I book an Ashtavinayak Darshan cab with Mauli Cabs?',
            answer: 'Booking an Ashtavinayak Darshan cab with Mauli Cabs is simple. You can visit our website or mobile app, select "Ashtavinayak Darshan" as your travel package, choose your vehicle, and confirm your booking. You can also call our support team for personalized assistance.',
        },
        {
            question: 'What types of cabs are available for the Ashtavinayak Darshan tour?',
            answer: 'We offer a variety of vehicles including Hatchbacks, Sedans, SUVs, Ertiga, and Innova Crysta for the Ashtavinayak Darshan tour. Choose the one that suits your group size and comfort preferences.',
        },
        {
            question: 'Is the fare for Ashtavinayak Darshan fixed?',
            answer: 'Yes, we offer fixed and transparent pricing for Ashtavinayak Darshan tours. The fare includes fuel, driver charges, and tolls. There are no hidden costs.',
        },
        {
            question: 'How long does the Ashtavinayak Darshan tour take?',
            answer: 'The complete Ashtavinayak Darshan typically takes around 2 to 3 days depending on your itinerary and pace. We can customize the schedule to suit your convenience.',
        },
        {
            question: 'Are the drivers familiar with the Ashtavinayak temple route?',
            answer: 'Yes, our drivers are experienced and well-versed with the Ashtavinayak temple circuit. They ensure a safe and timely journey, covering all the temples efficiently.',
        },
        {
            question: 'Can we customize our Ashtavinayak Darshan itinerary?',
            answer: 'Absolutely! You can tailor your itinerary according to your preferences. Just let us know your plan, and we’ll help organize your tour accordingly.',
        },
        {
            question: 'Is accommodation included in the Ashtavinayak Darshan package?',
            answer: 'Currently, our cab service covers travel only. However, we can assist you with recommendations for accommodations near the temples if needed.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mrs. Meena Joshi",
            position: "Devotee",
            text: "Our Ashtavinayak Darshan with Mauli Cabs was a spiritually fulfilling and hassle-free experience. The driver was polite and knowledgeable about all the temple locations. Highly recommend for family pilgrimages.",
            image: "/img/testimonial/testimonial-thumb-1-3.png",
        },
        {
            name: "Mr. Ramesh Deshmukh",
            position: "Senior Citizen",
            text: "Mauli Cabs made our Ashtavinayak journey very comfortable. The cab was clean, and the driver ensured we visited each temple peacefully. Great service and very respectful staff.",
            image: "/img/testimonial/testimonial-thumb-1-4.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Ashtavinayak Darshan Cab by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable cab services for the Ashtavinayak Darshan Yatra from Pune. Choose from cars, Innova Crysta, Ertiga, tempo traveller, mini bus, or 17-seater rentals for one-day or two-day pilgrimage packages. 24x7 booking available for a smooth and spiritual journey.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "6000"
        }
      };
      
     
    return (
        <div>
            <GTag/>
<KeywordProtectedPage/>
<Helmet>
        <title>Ashtavinayak Darshan Cab | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Ashtavinayak Darshan cab with Mauli Cabs from Pune. Get affordable packages for 1 or 2-day tours. Choose from tempo traveller, Innova, Ertiga, or 17-seater bus for a comfortable and spiritual journey. 24x7 booking available."
        />
        <meta
          name="keywords"
          content="cab for ashtavinayak darshan, Ashtavinayak Darshan Package from Pune, ashtavinayak darshan from pune in 2 days, pune to ashtavinayak taxi service, Pune to Ashtavinayak Tour Package, pune to ashtavinayak darshan package, Cheapest Ashtavinayak tour from Pune, Cheapest Tempo Traveller for Ashtavinayak Tour from Pune, pune to ashtavinayak cab, Ashtavinayak Yatra Tour Cabs, pune to ashtavinayak tempo traveller on rent, pune to ashtavinayak mini bus on rent, pune to ashtavinayak 17 seater Bus on Rent, pune to ashtavinayak ertiga On Rent, ashtavinayak tour from pune by car package, pune to ashtavinayak innova Crysta on Rent, Pune to ashtavinayak taxi fare"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      




            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/53.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Ashtavinayakdarshancab;